module.exports = __webpack_public_path__ + "79b02850081e27b3ba209e6ae60ad50f.svg";